import {generateTestIds} from '../../../../../../utils/test-utils/data-test-id/generateTestIds';

const SCOPE = 'trackers.current_weight';

const KEYS = [
  'button_more_current_weight',
  'button_more_reporting',
  'button_add_weight',
  'button_add_comment',
  'button_cancel_comment',
  'button_delete_comment',
  'button_decrease_weight',
  'button_increase_weight',
  'button_submit_weight',
] as const;

type Key = (typeof KEYS)[number];

export const TestID = generateTestIds<Key>(SCOPE, KEYS);
